<template>
  <div
    class="main scroll"
    @click="cancelContent"
    @contextmenu.prevent="contentRight($event)"
    ref="scroll"
  >
    <div class="scroll-wrapper">
      <div class="head-title">
        <div class="left">
          <div @click="$router.back()" class="name">学生相册</div>
          <div class="icon">></div>
          <div class="main blue">
            {{ studentName }}
          </div>
          <a-select
            style="width:160px;margin-left:10px"
            v-model="id"
            size="small"
            @change="changeType"
          >
            <a-select-option
              v-for="item in albumList"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</a-select-option
            >
          </a-select>
          <!-- <a-icon style="{color:#f1f8fd}" type="caret-down" /> -->
           <!-- <a-button style="margin-left:10px;font-size:12px" type="default" size="small" @click="downloadImgs">下载照片</a-button> -->
        </div>
        <div class="right">
          <div class="num">
            照片数量<span class="blue">{{ total }}</span>
          </div>
          <div class="msg">
            <div class="txt blue">相册信息</div>
            <a-icon style="{color:#898989}" type="caret-down" />
          </div>
        </div>
      </div>
      <div  class="content">
        <div class="frame-list">
          <img
            @click="uploadModal = true"
            class="addframe"
            :src="require('@/assets/upload-03.png')"
            alt=""
          />
          <div
            @click="selectPhoto($event, index)"
            @dblclick="showBigPic(item.img_url)"
            v-for="(item, index) in photoList"
            :key="index"
            @contextmenu.prevent="photoRight($event, index)"
            class="cell"
            :class="item.select ? 'select' : ''"
            :style="{backgroundImage:'url('+item.img_url+')'}"
          >
            <!-- <img class="photo" :src="item && item.img_url" alt="" /> -->
            <!-- <div v-if="item.is_sb && !item.binding" class="tip">已识</div>
            <div v-if="item.binding" class="bind">分配</div> -->
          </div>
        </div>
      </div>
      <div v-show="showRight" class="rightContent" :style="rightStyle">
        <div @click="uploadModal = true" class="cell">上传照片</div>
        <div v-if="currentIndex > -1" @click="showDisModel" class="cell">
          单图分配
        </div>
        <div @click="handleSelectAll" class="cell">选择全部</div>
        <div @click="removeModal = true" class="cell">移除照片</div>
      </div>
      <div class="pagebox">
        <a-pagination
              show-quick-jumper
              :defaultPageSize="23"
              :current="currentPage"
              :total="total"
              @change="onChangePage"
        />
      </div>
      <a-modal :visible="editModal" centered :closable="false" footer="">
        <div class="modal3">
          <img :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改相册名称</div>
            <a-input
              v-if="currentPhoto"
              v-model="currentPhoto.name"
              :placeholder="currentPhoto ? currentPhoto.name : ''"
            />
            <div class="btns">
              <a-button @click="editModal = false">取消</a-button>
              <a-button @click="handleEditPhoto" type="primary">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="delModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">删除此照片，不可恢复。是否继续？</div>
            <div class="btns">
              <a-button @click="delModal = false">取消</a-button>
              <a-button @click="handleDelPhoto" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="removeModal" centered :closable="false" footer="">
        <div class="modal3 red">
          <img :src="require('../assets/log2.png')" alt="" />
          <div class="msg">
            <div class="title">照片与学生解除关联。是否继续？</div>
            <div class="btns">
              <a-button @click="removeModal = false">取消</a-button>
              <a-button @click="handleRemovePhoto" type="danger">
                确认
              </a-button>
            </div>
          </div>
        </div>
      </a-modal>
      <a-modal :visible="previewVisible" width="800px" :footer="null" @cancel="handleCancel">
        <div style="padding:20px">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
      <a-modal
        :visible="uploadModal"
        centered
        :title="studentName + '-添加照片'"
        width="1180px"
        footer=""
        @cancel="uploadModal = false"
      >
        <div class="photos">
          <a-upload-dragger
            name="file"
            list-type="picture-card"
            :multiple="true"
            :file-list="fileList"
            :before-upload="beforeUpload"
            :action="$api.domain + $api.addPhoto"
            @preview="handlePreview"
            @change="handleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              点击或者拖拽图片到此处
            </p>
          </a-upload-dragger>
        </div>
      </a-modal>
      <a-modal
        :visible="disModal"
        centered
        :title="'分配照片'"
        width="1200px"
        ok-text="确认"
        cancel-text="取消"
        @ok="handleDis"
        @cancel="cancelDisModel"
      >
        <div class="photos">
          <div class="dis-list">
            <div v-if="currentIndex > -1" class="dis-cell">
              <img
                class="dis-photo"
                :src=" photoList[currentIndex].img_url"
                alt=""
              />
              <!-- <div v-if="photoList[currentIndex].is_sb && !photoList[currentIndex].binding" class="tip">已识</div>
              <div v-if="photoList[currentIndex].binding" class="bind">分配</div> -->
            </div>
          </div>
          <div class="section">
            <div class="head">
              <div class="name">学生列表：</div>
              <div @click="handleAllDis" class="alldis">全部分配</div>
              <div @click="handleRemoveStudent" class="allRemove">全部移除</div>
            </div>
            <div class="student-list">
              <div
                @click="selectStudent(index)"
                v-for="(item, index) in studentList"
                :key="index"
                class="student-cell"
                :class="item.select ? 'select' : ''"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { checkFileFormat } from "@/utils/validate";
// import BetterScroll from "better-scroll";
import _ from "lodash";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  data() {
    return {
      photoList: [],
      currentPhoto: null,
      currentIndex: -1,
      rightContentLeft: 0,
      rightContentTop: 0,
      showRight: false,
      photoName: "",
      editModal: false,
      delModal: false,
      backimg1: require("../assets/doc.png"),
      backimg2: require("../assets/doc-01.png"),
      id: "",
      studentId: "",
      studentName: "",
      removeModal: false,
      uploadModal: false,
      previewVisible: false,
      previewImage: "",
      fileList: [],
      type: "全部照片",
      disList: [],
      disModal: false,
      rightStyle: {
        left: 0,
        top: 0,
      },
      albumList: [],
      studentList: [],
      currentPage:1,
      total:0
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.scroll = new BetterScroll(this.$refs.scroll, {
    //     scrollY: true,
    //     scrollbar: true,
    //     mouseWheel: {
    //       speed: 20,
    //       invert: false,
    //       easeTime: 300,
    //     },
    //   });
    // });
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    this.studentName = this.$route.query.name;
    this.studentId = this.$route.params.studentId;
    if (this.userInfo) {
      this.getAlbum();
      this.getStudent();
    }
  },
  filters: {
    filterIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.getAlbum();
        this.getStudent();
      }
    },
  },
  methods: {
    // 上传前校验文件格式
    beforeUpload(file) {
      if (!checkFileFormat(file)) {
        this.$message.error("请上传图片格式的文件");
        return false;
      }
      return true;
    },
    clearUrl(url) {
      console.log(url)
      if(!url) {
        url = ''
      } else if (url.indexOf('?')) {
        url = url.split('?')[0]
      } 
      return url
    },
    showBigPic(url) {
      console.log(url)
      this.previewImage = this.clearUrl(url)
      this.previewVisible = true
    },
    onChangePage(e) {
      this.currentPage = e
      this.currentIndex = -1
      this.photoList = [] 
      this.getPhoto()
    },
    handleRemoveStudent() {
       this.studentList = this.studentList.map((arr) => {
        arr.select = false;
        return arr;
      });
    },
    getStudent() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentList,
        headers: { Authorization: this.$store.state.headers },
      })
        .then((res) => {
          this.studentList = res.data.data.rows;
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getAlbum() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.studentAlbum,
        headers: { Authorization: this.$store.state.headers },
        data: {
          student_id: this.studentId,
          limit:100
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data) {
            this.albumList = res.data.data.data;
            this.id = this.albumList[0].id;
            this.getPhoto();
          } else {
            this.$message.error("暂无内容");
          }
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    cancelDisModel() {
      this.photoList = this.photoList.map((arr) => {
        arr.select = false;
        return arr;
      });
      this.disModal = false;
    },
    handleAllDis() {
      this.studentList = this.studentList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    selectStudent(index) {
      this.studentList[index].select = !this.studentList[index].select;
      this.$forceUpdate();
    },
    showDisModel() {
      if (this.currentIndex > -1) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.img_info,
          headers: { Authorization: this.$store.state.headers },
          data: { album_id: this.photoList[this.currentIndex].id },
        })
          .then((res) => {
            if (res.data.status == 200) {
              if (res.data.data.binding && res.data.data.binding !== {}) {
                for (const id in res.data.data.binding) {
                  this.studentList.forEach((arr) => {
                    if (arr.id == id) {
                      arr.select = true 
                    }
                    return arr
                  });
                }
              }
              this.disModal = true
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleRemovePhoto() {
      var ids = [];
      this.photoList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.removeBind,
          headers: { Authorization: this.$store.state.headers },
          data: {
            student_id: this.studentId,
            album_img_ids: ids,
          },
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.removeModal = false;
              this.currentIndex = -1
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何相册");
      }
    },
    handleDis() {
      var student_ids = [];
      this.studentList.map((arr) => {
        if (arr.select) {
          student_ids.push(arr.id);
        }
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.disOnes,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_img_id: this.photoList[this.currentIndex].id,
          student_id: student_ids.join(","),
        },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          this.currentIndex = -1
          if (res.data.status == 200) {
            this.getPhoto();
            this.disModal = false;
          }
        })
        .catch(() => {
          this.$message.error("网络或服务器未知错误");
        });
    },
    changeType() {
      this.getPhoto();
    },
    handleUpload() {
      if (this.uploadState) return false;
      var img_url = [];
      var errors = []
      var state = true;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].status == 'done' && this.fileList[i].response && this.fileList[i].response.data) {
            img_url.push(this.fileList[i].response.data.url);
        } else if (this.fileList[i].status == 'uploading') {
          state = false;
          break;
        } else if (this.fileList[i].status == 'error' || this.fileList[i].response != 200) {
          errors.push(i+1)
        } 
      }
      if (!state) return false;
      if (errors.length > 0) {
        this.$message.error(`第${errors.join(',')}文件上传失败`)
      }
      if (img_url.length == 0) {
        this.uploadState = false;
        this.fileList = [];
        this.uploadModal = false;
        return false
      }
      this.uploadState = true;
      this.$message.loading({
        content: "Loading...",
        key: "uploadState",
        duration: 10,
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.addStudentPhoto,
        headers: { Authorization: this.$store.state.headers },
        data: {
          album_id: this.id,
          img_url: img_url.join(","),
          student_id: this.studentId,
        },
        timeout:10000
      })
        .then((res) => {
          this.uploadState = false;
          this.fileList = [];
          setTimeout(() => {
            this.$message.info({
              content: res.data.msg,
              key: "uploadState",
              duration: 2,
            });
          }, 1000);
          if (res.data.status == 200) {
            this.uploadModal = false;
            this.getPhoto();
          }
        })
        .catch(() => {
          this.uploadState = false;
          this.$message.error("网络或服务器未知错误");
        });
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
      this.handleUpload();
    },
    handleCancel() {
      this.previewVisible = false;
    },
    selectPhoto($event, index) {
      if ($event.shiftKey) {
        this.photoList = this.photoList.map((arr, arrIndex) => {
          arr.select = false;
          if (this.currentIndex >= index) {
            if (arrIndex >= index && arrIndex <= this.currentIndex) {
              arr.select = true;
            }
          } else {
            if (arrIndex <= index && arrIndex >= this.currentIndex) {
              arr.select = true;
            }
          }
          return arr;
        });
        this.currentIndex = index;
        return false;
      }
      if ($event.ctrlKey) {
        this.photoList[index].select = !this.photoList[index].select;
        this.$forceUpdate();
        this.currentIndex = index;
        return false;
      }
      if (!$event.shiftKey && !$event.ctrlKey) {
        this.photoList = this.photoList.map((arr, index2) => {
          arr.select = false;
          if (index2 == index) {
            arr.select = true;
          }
          return arr;
        });
        this.currentIndex = index;
      }
    },
    editPhoto(index) {
      this.currentPhoto = _.cloneDeep(this.photoList[index]);
      this.editModal = true;
    },
    handleSelectAll() {
      this.photoList = this.photoList.map((arr) => {
        arr.select = true;
        return arr;
      });
    },
    handleEditPhoto() {
      if (!this.currentPhoto) {
        this.$message.error("未填写任何姓名");
      } else {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.editPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { id: this.currentPhoto.id, name: this.currentPhoto.name },
        })
          .then((res) => {
            this.studentName = "";
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.editModal = false;
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      }
    },
    handleDelPhoto() {
      var ids = [];
      this.photoList.forEach((arr) => {
        if (arr.select) {
          ids.push(arr.id);
        }
      });
      if (ids.length > 0) {
        this.$axios({
          method: "POST",
          url: this.$api.domain + this.$api.delPhoto,
          headers: { Authorization: this.$store.state.headers },
          data: { album_img_id: ids.join(","), album_id: this.id },
        })
          .then((res) => {
            this.$message.info(res.data.msg);
            if (res.data.status == 200) {
              this.delModal = false;
              this.getPhoto();
            }
          })
          .catch(() => {
            this.$message.error("网络或服务器未知错误");
          });
      } else {
        this.$message.error("未选择任何相册");
      }
    },
    contentRight(e) {
      console.log(e);
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.photoList = this.photoList.map((arr) => {
        arr.select = false;
        return arr;
      });
      console.log(e);
    },
    cancelContent() {
      this.showRight = false;
    },
    photoRight(e, index) {
      e.stopPropagation();
      var clientWidth = document.body.clientWidth;
      var clientHeight = document.body.clientHeight;
      this.rightContentLeft =
        clientWidth - e.pageX < 120 ? e.pageX - 120 : e.pageX;
      if (clientHeight - e.pageY < 130) {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
          transform: "translateY(-100%)",
        };
      } else {
        this.rightStyle = {
          left: this.rightContentLeft + "px",
          top: e.pageY + "px",
        };
      }
      this.showRight = true;
      this.currentPhoto = _.cloneDeep(this.photoList[index]);
      if (!this.photoList[index].select) {
        this.photoList = this.photoList.map((arr) => {
          arr.select = false;
          return arr;
        });
        this.photoList[index].select = true;
      }
      this.currentIndex = index;
    },
    getPhoto() {
      this.$message.loading({
        key:'load',
        content:'加载中...'
      })
      this.$axios({
        method: "GET",
        url: this.$api.domain + this.$api.studentAlbumPhoto,
        headers: { Authorization: this.$store.state.headers },
        params: {
          album_id: this.id,
          student_id: Number(this.studentId),
          limit: 23,
          page: this.currentPage,
        },
      })
        .then((res) => {
          if (res.data.status == 200 && res.data.data.data.length > 0) {
            this.total = res.data.data.total
            this.photoList = res.data.data.data.map((arr) => {
              arr.select = false;
              arr.img_url += '?x-image-process=image/resize,w_200/quality,Q_80'
              return arr;
            });
            this.$message.success({content:'获取成功',key:'load',duration:1});
          } else {
            this.photoList = []
            this.$message.success({content:'暂无内容',key:'load',duration:1});
          }
          // this.$nextTick(() => {
          //   this.scroll = new BetterScroll(this.$refs.scroll, {
          //     scrollY: true,
          //     scrollbar: true,
          //     mouseWheel: {
          //       speed: 20,
          //       invert: false,
          //       easeTime: 300,
          //     },
          //   });
          // });
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("服务器或网络错误");
        });
    },
    downloadImgs() {
      this.$message.loading({
        key: 'download',
        content: '正在获取照片地址...'
      });
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.downloadImgs,
        headers: { Authorization: this.headers },
        data: {
          s_id: this.studentId
        }
      })
        .then((res) => {
          console.log(res);
          this.$message.destroy('download');
          if (res.data) {
            const urls = res.data;
            if (urls.length > 0) {
              // 创建txt文件内容
              const content = res.data
              // 创建Blob对象
              const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
              // 创建下载链接
              const url = URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.href = url;
              link.download = `${this.studentName}_photos.txt`;
              // 触发下载
              document.body.appendChild(link);
              link.click();
              // 清理
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              this.$message.success('照片地址下载成功');
            } else {
              this.$message.info('暂无照片地址');
            }
          } else {
            this.$message.error(res.data.msg || '获取照片地址失败');
          }
        })
        .catch((error) => {
          this.$message.destroy('download');
          console.error('下载照片地址失败:', error);
          this.$message.error('网络或服务器错误');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.student-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;
  flex-wrap: wrap;
  .student-cell {
    cursor: pointer;
    margin-bottom: 10px;
  }
  .tx {
    width: 60px;
    height: 60px;
    border-radius: 60px;
    margin-right: 30px;
  }
  .name {
    width: 60px;
    text-align: center;
    color: #888;
    margin-top: 10px;
    font-size: 14px;
  }
}
.scroll {
  position: absolute;
  left: -20px;
  right: -20px;
  padding-left: 20px;
  top: 0;
  bottom: 0;
  overflow: hidden;
  box-sizing: border-box;
  .scroll-wrapper {
    height: 100%;
    overflow-y: scroll;
    padding-right: 20px;
    box-sizing: border-box;
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }

  .cell {
    width: 175px;
    height: 143px;
    display: flex;
    flex-direction: row;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    position: relative;
    background-size: contain;
    background-position: center;
    background-color: #eee;
    background-repeat: no-repeat;
    .photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.frame-list div,
.frame-list span {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -ms-user-select: none;
}
::-webkit-scrollbar-track-piece {
  background-color: #f1f1f1;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  background-color: #a8b3bb;
  background-clip: padding-box;
  min-height: 28px;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}
.head-title .left .name {
  font-size: 12px;
}
.head-title .left .icon {
  margin: 0 6px;
}
::v-deep .ant-select-selection-selected-value {
  font-size: 12px;
}
::v-deep .ant-upload.ant-upload-drag {
  margin-bottom: 8px;
}
::v-deep .ant-upload-list {
  overflow: hidden;
}
.pagebox{
  text-align: center;
}
.allRemove {
    background: #e76969;
    margin-left: 10px;
    color: #fff;
    font-size: 12px;
    border-radius: 100px;
    padding: 4px 10px;
    cursor: pointer;
  }
.dis-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  .dis-cell {
    width: 175px;
    height: 143px;
    margin-bottom: 10px;
    box-sizing: border-box;
    margin-right: 10px;
    position: relative;
    .dis-photo {
      width: 100%;
      height: 100%;
    }
    .tip {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #67b0dc;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    .bind {
      position: absolute;
      left: 0;
      top: 0;
      padding: 2px 10px;
      box-sizing: border-box;
      color: #fff;
      background: #df815c;
      border-radius: 0 0 6px 0px;
      box-shadow: 2px 2px 2px 2px rgba($color: #000000, $alpha: 0.02);
    }
    &.select {
      border: 3px solid #67b0dc;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba($color: #000000, $alpha: 0.3);
      }
    }
  }
}
.section {
  width: 100%;
  margin-top: 5px;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .name {
      color: #67b0dc;
      margin-right: 6px;
    }
    .alldis {
      background: #67b0dc;
      color: #fff;
      font-size: 12px;
      border-radius: 100px;
      padding: 4px 10px;
      cursor: pointer;
    }
  }
  .student-list {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    .student-cell {
      padding: 4px 10px;
      width: 80px;
      border-radius: 20px;
      background: #f1f1f1;
      border: 1px solid #eee;
      color: #898989;
      margin-right: 10px;
      text-align: center;
      cursor: pointer;
      &.select {
        background: #67b0dc;
        color: #fff;
      }
    }
  }
}
</style>
